import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SortDirection } from "../../interfaces";
import { beachSelectors } from "../../redux";
import { loadAllBeach } from "../../redux/beach/sagaActions";

interface Column {
  id: "name" | "city" | "rows" | "totalSeats";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: "name", label: "Nome", minWidth: 100 },
  {
    id: "city",
    label: "Città",
    minWidth: 100,
    align: "right",
  },
  {
    id: "rows",
    label: "File",
    minWidth: 100,
    align: "right",
  },
  {
    id: "totalSeats",
    label: "Posti totali",
    minWidth: 100,
    align: "right",
  },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  addButton: {
    marginTop: 20,
  },
});

interface TableBeachProps {
  onEditBeach: (id: string) => void;
  onDeleteBeach: (id: string) => void;
}

const TableBeach: React.FC<TableBeachProps> = ({
  onDeleteBeach,
  onEditBeach,
}) => {
  const beaches = useSelector(beachSelectors.getAllBeaches);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const maxPage = Number(beaches.data?.totalCount);

  const handleSelectBeach = (id: string) => {
    id ? onEditBeach(id) : console.log(id, "id not found");
  };

  useEffect(() => {
    dispatch(loadAllBeach({}));
  }, [dispatch]);

  const handleChangePage = (event: unknown, newPage: number) => {
    if (newPage > page) {
      dispatch(
        loadAllBeach({
          start_after:
            beaches.data?.results[beaches.data?.results.length - 1].id,
          sort_by: [{ field: "uid", order: SortDirection.ASC }],
        })
      );
    } else {
      dispatch(
        loadAllBeach({
          end_before:
            beaches.data?.results[beaches.data?.results.length - 1].id,
          sort_by: [{ field: "uid", order: SortDirection.ASC }],
        })
      );
    }
    setPage(0);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const deleteBeach = (id: string) => {
    onDeleteBeach(id);
  };

  const formatCellValue = (columnField: string, value: any) => {
    switch (columnField) {
      case "city":
        return value.name;

      default:
        return value;
    }
  };

  if (!beaches.data || beaches.data?.results.length === 0) return null;

  return (
    <>
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell align="right">Modifica</TableCell>
                <TableCell align="right">Cancella</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {beaches.data?.results.map((row) => {
                return row && row.id ? (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column, index) => {
                      const value = row[column.id];
                      return (
                        <React.Fragment key={column.id + index}>
                          <TableCell align={column.align}>
                            {formatCellValue(column.id, value)}
                          </TableCell>
                        </React.Fragment>
                      );
                    })}
                    <TableCell align="right">
                      <Tooltip title="Modifica">
                        <IconButton
                          aria-label="edit"
                          onClick={() => row.id && handleSelectBeach(row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip title="Elimina">
                        <IconButton
                          aria-label="delete"
                          onClick={() => row.id && deleteBeach(row.id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ) : null;
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={maxPage}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage="N. elementi"
        />
      </Paper>
    </>
  );
};

export default React.memo(TableBeach);
